/**
 * NotasInseridas Configuracao
 * @author Thacryba
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'

export class NotasInseridasConfiguracao extends Resource {
  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  ehGrupoEconomico: boolean = false
  ativo: boolean = false

  get $id() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set $id(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  reset() {
    this.ehGrupoEconomico = false
    this.ativo = false
  }

  restart() {
    this.ehGrupoEconomico = false
    this.ativo = true
    this.responsavel = null
  }

  /**
   * Gets a instance of a given ID of NotasInseridasConfig
   */
  async getNotasInseridasConfiguracao(id: number) {
    return await Request.get(`/admin/notas-inseridas-configuracao/${id}`)
      .name('getNotasInseridasConfiguracao')
      .as(this)
      .getData()
  }

  /**
   * Persists a new instance of NotasInseridas. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistNotasInseridasConfiguracao() {
    return await Request.post(`/admin/notas-inseridas-configuracao`, this)
      .name('persistNotasInseridasConfiguracao')
      .asNumber()
      .getData()
  }
}
